<template lang="pug">
  .section-layout
    .nav-back-btn(@click="goBack")
    .content-top
      h2.title-filter 查看（模板活动）
    .content-wrapper
      .step-title 1.活动模板
      .table-wrapper
        table.table
          thead
            tr
              td(width="120") 封面图
              td(width="260") 模板标题
              td(width="200") 模板分类
              td(width="100") 操作
          tbody
            tr
              td
                .icon-img(v-if="info.cover_img")
                  img(:src="info.cover_img")
                .simple-null(v-else) --
              td
                .simple-td(v-text="info.template_name")
              td
                .simple-td(v-text="info.category_name")
              td
                a(@click="showAddModel(info)") 海报预览
      //- 海报预览
      slide-out-modal(v-if="slideVisible" @input="showAddModel")
        view-poster(:poster_info="poster_info")
      .step-title 2.活动信息配置
      .form-wrapper
        .field-group
          .field.is-horizontal
            label.label.must 名称
            custom-input(v-model.trim="info.title", :isDisabled="true")
          .field.is-horizontal
            label.label.must 活动时间
            div(v-text="info.time")
          .field.is-horizontal
            label.label.must 活动说明
            div(style="flex-grow: 1;")
              custom-textarea(v-model="info.description", :isDisabled="true")
              //- .desc-text 活动说明的文字，会在活动海报中展示出来
          .field.is-horizontal
            label.label.must 活动内容
            div(style="flex-grow: 1;")
              custom-textarea(v-model="info.content", :isDisabled="true")
              .control.image-wrapper
                .upload-pic(v-for="(cell, index) in info.content_imgs")
                  upload-img-model(v-model="info.content_imgs[index]", :isDisabled="true", img-type="item", :has-second-action="false")
          .field.is-horizontal
            label.label.must 海报上传
            .control.image-wrapper
              .upload-poster
                upload-img-model(v-model="info.poster_img", :isDisabled="true", img-type="item", :has-second-action="false", lookPicText="预览海报", @previewPosters="showAddModel(info)")
          .field.is-horizontal
            label.label.must 轮播图配置
            .control.image-wrapper
              .upload-poster
                upload-img-model(v-model="info.slider_img", :isDisabled="true", img-type="item", :has-second-action="false",)
          .field.is-horizontal
            label.label
            ul
              li.font-des 1、建议上传尺寸为750x340的jpg/png格式文件，文件不能超过1M；
              li.font-des 2、轮播图默认跳转为该活动页；
              li.font-des 3、活动上架后，已配置的轮播图将可以直接上架；
          .field.long.is-horizontal
            label.label 优惠券配置
            span(v-if="!info.coupons.length", style="color: #888;") 未配置优惠券
            .box(v-else)
              ul.clearfix.coupon
                li.fl.w-80 类型
                li.fl.w-180 名称
                li.fl.w-80 金额
                li.fl 使用条件
                li.fl.w-180 有效时间
              ul.clearfix.coupon-list(v-for="(item, index) in info.coupons")
                li.fl.w-80(v-if="item.coupon_type == 1") 代金券
                li.fl.w-80(v-if="item.coupon_type == 2") 兑换券
                li.fl.w-80(v-if="item.coupon_type == 3") 满减券
                li.fl.w-80(v-if="item.coupon_type == 4") 折扣券
                li.fl.w-180(:title="item.item_name") {{item.item_name}}
                li.fl.w-80(v-if="item.coupon_type != 4") {{item.discount_amount/100}}元
                li.fl.w-80(v-if="item.coupon_type == 4") {{item.discount_amount/100}}折
                li.fl {{item.condition_value == 0 ? '无限制' : '满'+ item.condition_value/100 + '元可用'}}
                li.fl.w-180(v-if="item.effective_type == 3") 无限制
                li.fl.w-180(v-if="item.effective_type == 2") 自领取{{item.effective_days}}
                li.fl.w-180(v-if="item.effective_type == 1") {{item.effective_days}}
          .field.long.is-horizontal
            label.label.must 活动门店
            .box
              ul.clearfix.coupon
                li.fl.w-30(v-html="'<pre> </pre>'")
                li.fl.w-180 门店名称
                li.fl 联系电话
                li.fl.w-350 地址
              ul.clearfix.coupon-list(v-for="(item, index) in info.store")
                li.fl.w-30 
                  .checkbox.disabled
                    input(type="checkbox", v-model="store_list", :value="item", :disabled="true")
                    label
                li.fl.w-180 {{item.store_name}}
                li.fl {{item.business_phone}}
                li.fl.w-350(:title="`${item.province_name + item.city_name}市${item.district_name}区${item.address}`") {{`${item.province_name + item.city_name}市${item.district_name}区${item.address}`}}
          .field.is-horizontal
            label.label.must 用户限制
            div.type-item
              .radio.disabled
                input(type="radio", v-model="info.user_limit", id="limit-0", :value="0", disabled)
                label.sepcific-setting(for="limit-0") 无限制
            div.type-item(v-if="info.user_limit == 1")
              .radio.disabled
                input(type="radio", v-model="info.user_limit", id="limit-1", :value="1", disabled)
                label.sepcific-setting(for="limit-1") 人群限制
            div.type-item(v-if="info.user_limit == 2")
              .radio.disabled
                input(type="radio", v-model="info.user_limit", id="limit-1", :value="2", disabled)
                label.sepcific-setting(for="limit-1") 人群限制
            div(v-if="info.user_limit != 0", style="margin-top: -2px; font-size: 13px;") 
              span(v-if="info.user_limit == 1") (小程序已下单客户)
              span(v-if="info.user_limit == 2") (小程序未下单客户)
          .field.is-horizontal
            label.label.must 报名方式
            .checkbox.disabled
              input(type="checkbox", v-model="register_type", value="1", disabled)
              label 车牌
            .checkbox.disabled
              input(type="checkbox", v-model="register_type", id="auto-info", value="2")
              label(for="auto-info") 车辆信息
            .checkbox.disabled
              input(type="checkbox", v-model="register_type", id="distance", value="3")
              label(for="distance") 行驶里程
            //- .checkbox.disabled
            //-   input(type="checkbox", v-model="register_type", id="distance", value="3")
            //-   label(for="distance") 
          //- .field.is-horizontal
          //-   label.label.must 小程序报名用户
          //-   .checkbox.disabled
          //-     input(type="checkbox", v-model="info.sign_up_switch", value="1", disabled)
          //-     label(for="sign_up_switch") 小程序页面报名成功用户展示
      .step-title 3.活动组件配置
      .activity-wrapper
        .phone-wrapper
          .phone-contents
            .phone-header
              .phone-top
                img(width="375", src="../../assets/template/mobile-header.png")
              .phone-head
                .phone-title {{info.title}}
                img(class="phone-icon", src="../../assets/template/mobile-button.png")
                
            .phone-content
              //- 固定项目
              .phone-item-box
                //- 封面图
                .cover-img
                  img.img-banner(:src="info.cover_img")
                  .time(v-if="info.time") 活动时间：{{info.time}}
                //- 车辆信息
                .car-info
                  img(v-if="info.register_type == '1'", width="100%", src="../../assets/template/mobile-car1.png")
                  img(v-if="info.register_type == '1,2'", width="100%", src="../../assets/template/mobile-car2.png")
                  img(v-if="info.register_type == '1,2,3'", width="100%", src="../../assets/template/mobile-car3.png")
                  img(v-if="info.register_type == '1,3'", width="100%", src="../../assets/template/mobile-car4.png")
                //- 活动图文描述
                .editor-wrapper
                  pre.editor-text(v-html="info.content")
                  img.editor-img(v-if="info.content_imgs.length > 0", v-for="item in info.content_imgs" :src="item")
              .phone-item-box
                .phone-item(v-for="(item, index) in info.relation", :key="index")
                  .goods-wrapper(v-if="item.type === 3 || item.type === 4")
                    goods(:goodsItem="item")
                  .card-wrapper(v-if="item.type === 5")
                    card(:cardItem="item")
                  .group-mange-wrapper(v-if="item.type === 6")
                    groupCategory(:groupCategoryItem="item")
                  .time-limit-wrapper(v-if="item.type === 7")
                    timeLimitGoods(:timeLimitGoodsItem="item")
                  .help-wrapper(v-if="item.type === 9")
                    help(:helpItem="info.help_info")
                  .help-wrapper(v-if="item.type === 10")
                    img(width="100%", src="../../assets/template/user.png")

        //- 编辑区域
        .edit-wrapper(v-if="is_help_info")
          .content.field-group(v-if="active_type === 9")
            .label-title 
              span 基本信息配置
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 助力时长
                custom-input(
                  v-model="info.help_info.duration", 
                  need-type="number" 
                  input-type="hasUnit",
                  maxlength=3,
                  placeholder="上限为999小时",
                  :isDisabled="true")
                  span(slot="unitName") 小时
              .is-red 用户发起助力时间到助力截止时间
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 助力人数
                custom-input(
                  v-model="info.help_info.num", 
                  need-type="number" 
                  input-type="hasUnit",
                  maxlength=2,
                  max="10"
                  placeholder="上限为10人",
                  :isDisabled="true")
                  span(slot="unitName") 人
              .is-red 助力活动的参与的人数，当达到参与人数，助力活动成功
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 活动助力总数
                custom-input(
                  :isDisabled="true"
                  v-model="info.help_info.help_total", 
                  need-type="number" 
                  input-type="hasUnit",
                  maxlength=3, 
                  error-info="活动助力总数不能为空"
                  max="999"
                  placeholder="输入0代表无限制",)
                  span(slot="unitName") 次
              .is-red 本次助力活动，允许发起者成功助力的总数量
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 发起助力限制
                .field.is-horizontal
                  span(style="width: 80px; font-size: 12px; flex-shrink: 0") 每人可发起
                  custom-input(
                    v-model="info.help_info.launch_num",
                    need-type="number" 
                    input-type="hasUnit",
                    maxlength=2,
                    placeholder="上限为99次",
                    :isDisabled="true")
                    span(slot="unitName") 次
              .is-red 每位发起助力活动的人，可发起的最大上限次数
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 参与助力限制
                .radio.disabled
                  input(id="limit01" type="radio" name="limit" v-model="info.help_info.limit" :value="0" disabled)
                  label(for="limit01") 无限制
                .radio.disabled.m-l-20
                  input(id="limit02" type="radio" name="limit" v-model="info.help_info.limit" :value="1" disabled)
                  label(for="limit02") 新用户
            .field.is-horizontal(v-if="info.help_info.limit === 0")
              .width-300.field.is-horizontal
                label.label
                .field.is-horizontal
                  span(style="width: 80px; font-size: 12px; flex-shrink: 0") 每人可参与
                  custom-input(
                    v-model="info.help_info.assist_num", 
                    need-type="number"
                    input-type="hasUnit",
                    maxlength=2,
                    placeholder="上限为99次",
                    :isDisabled="true")
                    span(slot="unitName") 次
              .is-red 每位参与助力活动的人，可参与的最大上限次数
            .field.is-horizontal
              label.label 助力规则
              .control-box
                textarea.textarea(v-model="info.help_info.rule", maxlength="500",placeholder="最多500个字", disabled)
            .label-title 奖励配置
            .field.is-horizontal
              label.label 发起者奖励
              .radio.disabled
                input(type="radio" name="choose" v-model="info.help_info.type" :value="1" disabled)
                label
              span.m-l-20.tips(v-if="info.help_info.coupon_items.length > 0") 已选择{{info.help_info.coupon_items.length}}张
            .coupon-lists(v-if="info.help_info.coupon_items.length > 0")
              el-row.thead
                el-col(:span="8") 名称
                el-col(:span="4")  类型
                el-col(:span="5")  金额/折扣
                el-col(:span="6")  使用范围
              el-row.tbody(v-for="(item, cindex) in info.help_info.coupon_items", :key="cindex")
                el-col(:span="8") {{item.coupon_name}}
                el-col(:span="4")
                  .simple-td(v-if="item.coupon_type === 1") 代金券
                  .simple-td(v-if="item.coupon_type === 2") 兑换券
                  .simple-td(v-if="item.coupon_type === 3") 满减券
                  .simple-td(v-if="item.coupon_type === 4") 折扣券
                el-col(:span="5") {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                el-col(:span="6")
                  div(v-if="item.coupon_use_type")
                    .simple-td(v-if="item.coupon_use_type === 1") 小程序商城通用
                    .simple-td(v-if="item.coupon_use_type === 2") 指定分类
                    .simple-td(v-if="item.coupon_use_type === 3") 指定商品/服务
                    .simple-td(v-if="item.coupon_use_type === 4") 指定养护卡
                    .simple-td(v-if="item.coupon_use_type === 5") 线下买单/开单
                  div(v-else) --
            .field.is-horizontal
              label.label 助力者奖励
              .radio.disabled
                input(type="radio" name="helperchoose" id="help-choose1" v-model="info.help_info.helper_type" :value="0" disabled)
                label.plain-txt(for="help-choose1") 无奖励
              .radio.disabled
                input(type="radio" name="helperchoose"  id="help-choose2" v-model="info.help_info.helper_type" :value="1" disabled)
                label.plain-txt(for="help-choose2") 有奖励
              span.m-l-20.tips(v-if="info.help_info.helper_type===1 && info.help_info.helper_coupons.length > 0") 已选择{{info.help_info.helper_coupons.length}}张
            .coupon-lists(v-if="info.help_info.helper_type===1 && info.help_info.helper_coupons.length > 0")
              el-row.thead
                el-col(:span="8") 名称
                el-col(:span="4")  类型
                el-col(:span="5")  金额/折扣
                el-col(:span="6")  使用范围
              el-row.tbody(v-for="(item, cindex) in info.help_info.helper_coupons", :key="cindex")
                el-col(:span="8") {{item.coupon_name}}
                el-col(:span="4")
                  .simple-td(v-if="item.coupon_type === 1") 代金券
                  .simple-td(v-if="item.coupon_type === 2") 兑换券
                  .simple-td(v-if="item.coupon_type === 3") 满减券
                  .simple-td(v-if="item.coupon_type === 4") 折扣券
                el-col(:span="5") {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                el-col(:span="6")
                  div(v-if="item.coupon_use_type")
                    .simple-td(v-if="item.coupon_use_type === 1") 小程序商城通用
                    .simple-td(v-if="item.coupon_use_type === 2") 指定分类
                    .simple-td(v-if="item.coupon_use_type === 3") 指定商品/服务
                    .simple-td(v-if="item.coupon_use_type === 4") 指定养护卡
                    .simple-td(v-if="item.coupon_use_type === 5") 线下买单/开单
                  div(v-else) --


      //- 底部按钮
      .btn-wrapper
        .button-group
          a.button.large(@click="goBack") 返回
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '@/mixins/modules/Content'
import SlideOutModal from '@/components/generics/SlideOutModal'
import ViewPoster from '@/components/content/modal/ViewPoster'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomTextarea from '@/components/generics/form/CustomTextarea'
import uploadImgModel from '@/components/content/modal/uploadImgModel'
import Goods from '@/components/content/modal/Goods'
import Card from '@/components/content/modal/Card'
import GroupCategory from '@/components/content/modal/GroupCategory'
import TimeLimitGoods from '@/components/content/modal/TimeLimitGoods'
import Help from '@/components/content/modal/Help'
export default {
  name: 'ContentView',
  mixins: [Api],
  components: {
    SlideOutModal,
    ViewPoster,
    CustomInput,
    CustomTextarea,
    uploadImgModel,
    Goods,
    Card,
    GroupCategory,
    TimeLimitGoods,
    Help,
  },
  data () {
    return {
      activity_id: '', // 活动id
      active_type: 9, // 当前选中的组件类型(右边编辑展示用)
      info: {
        coupons: [],
        help_info: {
          duration: '', // 助力时长
          num: '', // 助力人数
          rule: '', // 助力规则
          limit: 0, // 参与助力限制 0 无限制, 1 新用户
          launch_num: 1, // 发起次数
          assist_num: 1, // 参与次数
          type: 1,
          coupon_ids: [], // 优惠券id
          coupon_items: [], // 优惠券
          helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
          helper_coupons: [], // 助力者奖励券
          helper_coupon_ids: [], // 助力者奖励券的id集合
        },
      },
      register_type: [], // 已选择报名方式列表
      store_list: [], // 选择的模板组件
      slideVisible: false, // 海报预览弹框显示状态
      poster_info: {}, // 海报信息
      is_help_info: false, // 是否显示助力活动区域
    }
  },
  computed: {
    ...mapGetters({
      currentStore: 'currentStore',
    }),
  },
  methods: {
    // 返回列表页
    goBack () {
      this.$router.push({
        name: 'contentList',
      })
    },

    /**
     * 时间戳转年月日+时分秒
     * @val  时间戳
     */
    changeDate (val) {
      if (!val) {
        return ''
      }
      let date = new Date(val * 1000)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.judgeTime(date.getDate()) + ' '
      return Y + M + D
    },

    /**
     * 时 分 格式化
     * @t  时分
     */
    judgeTime (t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    },

    // 海报预览模态框(参数为info)
    async showAddModel (item) {
      // 关闭组件不请求接口
      if (!this.slideVisible) {
        let posterInfo = JSON.parse(JSON.stringify(item))
        posterInfo.start_time = this.changeDate(item.start_time).trim().replace(/-/g, '.')
        posterInfo.end_time = this.changeDate(item.end_time).trim().replace(/-/g, '.')
        posterInfo.store_name = this.currentStore.store_name
        posterInfo.address = this.currentStore.address
        this.poster_info = posterInfo
        this.poster_info.qr_code = await this.getActivityStoreQrCode(item.activity_id)
      }
      this.slideVisible = !this.slideVisible
    },

    // 活动详情
    async getActivityStoreDetail () {
      try {
        const { response, result } = await this.GetActivityStoreDetailApi({
          activity_id: this.activity_id,
        })
        if (response.status === 200 && result.code === 0) {
          // 调活动详情（编辑）接口的时候，后端返回来的封面图字段是cover
          result.data.cover_img = result.data.cover
          result.data.goods_data = [] // 商品列表
          result.data.service_data = [] // 服务列表
          result.data.upkeep_card_data = [] // 养护卡列表
          result.data.group_mange_data = [] // 拼团列表
          result.data.time_limit_data = [] // 秒杀列表
          result.data.coupon_data = [] // 优惠券列表
          result.data.help_info = {
            duration: '', // 助力时长
            num: '', // 助力人数
            rule: '', // 助力规则
            limit: 0, // 参与助力限制 0 无限制, 1 新用户
            launch_num: 1, // 发起次数
            assist_num: 1, // 参与次数
            type: 1,
            coupon_ids: [], // 优惠券id
            coupon_items: [], // 优惠券
            helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
            helper_coupons: [], // 助力者奖励券
            helper_coupon_ids: [], // 助力者奖励券的id集合
          }
          result.data.time = `${this.changeDate(result.data.start_time).trim()} 至 ${this.changeDate(result.data.end_time).trim()}`
          // 处理门店列表回显
          let StoreListArr = result.data.store_list.trim().split(',')
          for (let i = 0; i < StoreListArr.length; i++) {
            for (let x = 0; x < result.data.store.length; x++) {
              if (StoreListArr[i] === result.data.store[x].store_id.toString()) {
                this.store_list.push(result.data.store[x])
              }
            }
          }
          // 处理报名方式回显
          this.register_type = []
          let registerListArr = result.data.register_type.split(',')
          for (let i = 0; i < registerListArr.length; i++) {
            this.register_type.push(registerListArr[i])
          }
          let relation = []
          result.data.relation.forEach(item => {
            // 关联对象类型1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券, 9、助力活动
            switch (item.type) {
              case 3:
                relation.push({
                  type: 3,
                  shop_product_id: item.item_id,
                  name: item.item_name,
                  pic: item.item_pic,
                  mini_price: item.sell_price,
                  item_extra_id: item.item_extra_id,
                })
                break
              case 4:
                relation.push({
                  type: 4,
                  product_id: item.item_id,
                  pic: item.item_pic,
                  name: item.item_name,
                  mini_price: item.sell_price,
                  item_extra_id: item.item_extra_id,
                })
                break
              case 5:
                relation.push({
                  type: 5,
                  id: item.item_id,
                  image_url: item.item_pic,
                  name: item.item_name,
                  num: item.num,
                  price: item.sell_price,
                  origin_price: item.origin_price,
                })
                break
              case 6:
                relation.push({
                  type: 6,
                  id: item.item_id,
                  num: item.num,
                  product_name: item.item_name,
                  goods_price: item.group_price,
                  pic: item.item_pic,
                  mini_price: item.group_price,
                  origin_price: item.sell_price,
                })
                break
              case 7:
                relation.push({
                  type: 7,
                  id: item.item_id,
                  product: {
                    name: item.item_name,
                    seckill_sku_price: item.sell_price,
                    sku_price: item.sell_price,
                    inventory_total: item.inventory_total,
                    pic: item.item_pic,
                    mini_price: item.limit_price,
                    origin_price: item.sell_price,
                  },
                })
                break
              case 9:
                relation.push({
                  type: 9,
                })
                let content = item.content
                result.data.help_info = {
                  duration: content.duration,
                  num: content.num,
                  rule: content.rule, // 助力规则
                  limit: content.assist_num ? 0 : 1, // 参与助力限制 0 无限制, 1 新用户
                  launch_num: content.launch_num, // 发起次数
                  type: 1,
                  assist_num: content.assist_num || 1, // 参与次数
                  coupon_items: content.coupon, // 优惠券id,
                  helper_coupons: content.assist_coupon, // 助力者优惠券
                  helper_type: content.assist_prize, // 是否开启助力者奖励
                  helper_coupon_ids: content.assist_coupon.map(a => a.coupon_id),
                  help_total: content.help_total,
                }
                result.data.help_info.coupon_ids = content.coupon.map(cell => {
                  return cell.coupon_id
                })
                // this.button_list[8].disabled = true
                break
              case 10:
                relation.push({
                  type: 10,
                })
                break
              default:
                break
            }
          })
          result.data.relation = relation
          result.data.relation.forEach(item => {
            switch (item.type) {
              case 3:
                result.data.goods_data.push(item)
                break
              case 4:
                result.data.service_data.push(item)
                break
              case 5:
                result.data.upkeep_card_data.push(item)
                break
              case 6:
                result.data.group_mange_data.push(item)
                break
              case 7:
                result.data.time_limit_data.push(item)
                break
              default:
                break
            }
          })
          this.$nextTick(() => {
            this.info = result.data
          })
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动详情数据失败',
          content: `错误：${err}`,
        })
      }
    },

    // 获取活动二维码（模板活动海报预览用）传活动id
    async getActivityStoreQrCode (id) {
      try {
        const { response, result } = await this.GetActivityStoreQrCodeApi({
          id,
        })
        if (response.status === 200 && result.code === 0) {
          return result.data.image
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取中央活动库详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动二维码失败',
          content: `错误：${err}`,
        })
      }
    },
  },
  async mounted () {
    this.activity_id = this.$route.query.activity_id
    await this.getActivityStoreDetail()
    this.info.relation.forEach(item => {
      switch (item.type) {
        case 9:
          this.is_help_info = true
          break
        default:
          break
      }
    })
  },

}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/modules/creation-modal'
.nav-back-btn
  position absolute
  top 14px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.content-top
  height 60px
  h2
    padding 16px 60px
    font-size 100%
.content-wrapper
  height 100%
  margin 10px 40px 25px 40px
  padding 20px
.step-title
  padding 20px 0
.table-wrapper
  flex-grow 0
  overflow-x visible
  overflow-y visible
.icon-img
  height 36px
.icon-img img
  width 36px
  height 36px
// 活动信息配置
.form-wrapper
  border 0
.field-group
  border-bottom 0
.form-wrapper .field.long
  min-width 900px
  font-size 12px
label
  position relative
.must:before
  content '*'
  color #f56c6c
  position absolute
  left -15px
  top 3px
  font-size 15px
.desc-text
  color red
  height 12px
  position relative
  font-size 12px
.upload-pic
  display inline-block
  margin-top 4px
  width 120px
  height 120px
  margin-right 8px
.upload-poster
  display inline-block
  margin-top 4px
  width 200px
  height 120px
  margin-right 8px
.font-des
  font-size 12px
  color red
  margin-bottom 5px
// 选择优惠券表格
.box
  width 750px
.coupon
  background-color #f0f1f2
  padding-left 8px
  .w-30
    width 30px
  .w-60
    width 60px
  .w-180
    width 180px
  .w-200
    width 260px
  .w-350
    width 350px
  li
    width 94px
    margin-right 20px
    line-height 36px
  li.operation
    width 50px
    text-align center
  li:last-child
    margin-right 0
.coupon-list
  padding-left 8px
  border-bottom 1px solid #eee
  cursor pointer
  border-left 2px solid transparent
  .w-30
    width 30px
  .w-60
    width 60px
  .w-180
    width 180px
  .w-200
    width 260px
  .w-350
    width 350px
  li
    width 94px
    margin-right 20px
    line-height 34px
    white-space nowrap
    text-overflow ellipsis
    height 34px
    overflow hidden
    color #666
  li.operation
    width 50px
    text-align center
  li:last-child
    margin-right 0
.coupon-list:hover
  border-left 2px solid #ffc723
  box-shadow 0 2px 8px 0 rgba(0, 0, 0, 0.08)
.clearfix:after
  content '.'
  display block
  height 0
  clear both
  visibility hidden
.fl
  float left
.type-item
  display inline-flex
  min-width 88px
.checkbox
  margin-right 20px
.change-box
  margin-top 30px
  display flex
  justify-content space-between
  align-items center
  font-size 13px
.btn-people
  margin-top 60px
.not-allow
  cursor not-allowed
.radio.disabled
  pointer-events none
  opacity 0.5
// 活动组件配置
.activity-wrapper
  padding 12px
  // display flex
  // justify-content space-between
  width 100%
  // height 600px
.phone-wrapper
  width 375px
  padding-top 16px
  float left
.phone-contents
  width 375px
  background linear-gradient(360deg, rgba(251, 206, 7, 1) 0%, rgba(255, 155, 0, 1) 100%)
  border 1px solid #E4E4E4
.phone-header
  position relative
  width 373px
  background #fff
  .phone-head
    position relative
    height 42px
    line-height 42px
    text-align center
    .phone-title
      margin 0 auto
      width 160px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .phone-icon
      position absolute
      top 3px
      right 8px
      width 87px
      height 32px
.phone-content
  padding-top 15px
  .phone-item-box
    margin 2px 0
    position relative
    .cover-img
      position relative
      width 375px
      height 140px
      margin-bottom 40px
      .img-banner
        width 375px
        height 140px
      .time
        width 239px
        height 30px
        background linear-gradient(90deg, rgba(255, 155, 0, 1) 0%, rgba(255, 62, 0, 1) 100%)
        border-radius 16px
        font-size 12px
        color #fff
        text-align center
        line-height 30px
        position absolute
        bottom -15px
        left 68px
    .car-info
      width 352px
      margin 0 auto 44px
    .phone-item
      padding 0 15px
      min-height 112px
.editor-wrapper
  width 335px
  margin 0 auto
  position relative
  margin-bottom 30px
  padding 36px 15px 20px 15px
  min-height 100px
  word-wrap break-word
  background #FFFAE3
  .editor-img
    width 305px
    height auto
    margin-bottom 10px
  .editor-text
    color #404040
    font-size 14px
    line-height 26px
    white-space pre-wrap
    word-wrap break-word
  &:after
    content '活动内容'
    width 355px
    height 36px
    line-height 36px
    font-size 16
    font-weight 600
    display block
    text-align center
    color #fff
    position absolute
    top -15px
    left 50%
    transform translateX(-50%)
    background url('~@/assets/template/mobile-title.png') no-repeat center
    background-size 355px 36px
.enroll-wrapper
  position relative
  margin-bottom 20px
  .num
    position absolute
    bottom 2px
    padding-left 20px
    width 200px
    height 45px
    line-height 45px
    font-size 14px
    color #404040
    background #E8C18E
.content-wrapper
  height 100%
.line-wrapper
  width 2px
  height 100%
  background #ccc
.edit-wrapper
  padding-left 12px
  height 100%
  width calc(100% - 395px)
  float right
  .field-group
    border-bottom 0
  .enroll
    .store_wrapper
      margin-bottom 12px
  .control-box
    width 375px
    /deep/ .ql-editor
      width 100%
      p
        word-wrap break-word
// 助力活动
.width-300
  width 300px
  flex-shrink 0
.is-red
  font-size 12px
  color red
  margin-left 20px
.label-title
  padding 20px 0
div::-webkit-scrollbar
  width 10px
  height 10px
div::-webkit-scrollbar-thumb
  background #bfbfbf
  border-radius 10px
.m-l-20
  margin-left 20px
.coupon-lists
  line-height 26px
  font-size 14px
  margin-top 20px
  box-sizing border-box
  padding 0 20px
  color #555
  .thead
    background #f0f1f2
.tips
  font-size 12px
  color #666
.plain-txt
  font-size 12px
  margin-right 10px
// 底部按钮
.btn-wrapper
  // padding 50px 180px 0
  padding 50px 0 0
  .button-group
    display flex
    justify-content center
    align-items center
</style>


// WEBPACK FOOTER //
// src/components/content/ContentView.vue